<template>
  <v-row>

    <v-col cols="12" v-if="!loading" class="pt-2">
      <v-sheet
        class="content-editor"
        outlined 
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Términos y condiciones:</h3>
          </v-col>

          <v-col
            cols="12"
          >
            <vue-editor
              class="editor"
              :editor-toolbar="customToolbar"
              v-model="terms_and_conditions">
            </vue-editor>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateTermsConditions()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { VueEditor } from "vue2-editor";

  export default {
    name: 'termsConditionsEdition',
    components: {
      VueEditor
    },
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      edition:[],
      terms_and_conditions:'',
      error:false,
      errors:[],
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'align': [] }]
      ]
    }),

    methods:{
      async getEdition(){
        await axios.get('admin/editions/'+this.edition_id).then(response =>{
          this.edition = response.data.edition
          if(response.data.edition.terms_and_conditions!=null){
            this.terms_and_conditions = response.data.edition.terms_and_conditions
          }
          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateTermsConditions(){
        
        this.loading_update=true
        this.error = false
        this.errors = []

        try {
          await axios.put('admin/editions/'+this.edition_id+'/terms-conditions',{
            terms_and_conditions: this.terms_and_conditions
            }).then(() =>{
              if(this.errors.length===0){
                this.$router.push({ name: 'editEdition', params: { id: this.edition_id } })  
              }
              })
          } 
        catch (error) {
          //console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error[0])
          })
        }

        if(this.errors.length!=0){
          this.loading_update=false
          this.error=true
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getEdition()
    },
  }
</script>
<style>
.content-editor {
  height: 460px;
}

.editor {
  height: 320px;
}
</style>
